export const animals = [
	"albatross",
	"alligator",
	"alpaca",
	"anaconda",
	"angelfish",
	"ant",
	"anteater",
	"antelope",
	"ape",
	"baboon",
	"badger",
	"barbel",
	"bat",
	"bear",
	"beaver",
	"bee",
	"beetle",
	"bird",
	"bison",
	"blackbird",
	"boar",
	"bobcat",
	"bulldog",
	"bullock",
	"bumblebee",
	"butterfly",
	"buzzard",
	"camel",
	"canary",
	"capybara",
	"carp",
	"cat",
	"cheetah",
	"chicken",
	"chipmunk",
	"clownfish",
	"cobra",
	"cockroach",
	"cod",
	"cougar",
	"cow",
	"cowfish",
	"coyote",
	"crab",
	"crocodile",
	"crossbill",
	"crow",
	"cuckoo",
	"dachshund",
	"deer",
	"dingo",
	"dog",
	"dolphin",
	"donkey",
	"dove",
	"dragonfly",
	"duck",
	"eagle",
	"earthworm",
	"eel",
	"elephant",
	"elk",
	"emu",
	"falcon",
	"felix",
	"finch",
	"fireant",
	"firefox",
	"fish",
	"flamingo",
	"flea",
	"florian",
	"fly",
	"fox",
	"frog",
	"gadfly",
	"gazelle",
	"gecko",
	"gibbon",
	"giraffe",
	"goat",
	"goldfish",
	"goose",
	"gopher",
	"gorilla",
	"grebe",
	"grizzly",
	"gull",
	"guppy",
	"haddock",
	"halibut",
	"hamster",
	"hare",
	"hawk",
	"hedgehog",
	"herring",
	"hornet",
	"horse",
	"hound",
	"husky",
	"hyena",
	"ibex",
	"iguana",
	"impala",
	"insect",
	"jackal",
	"jackdaw",
	"jaguar",
	"jan",
	"jannes",
	"javelina",
	"jay",
	"jellyfish",
	"jurgen",
	"kangaroo",
	"kestrel",
	"kitten",
	"koala",
	"kudu",
	"ladybug",
	"lamb",
	"lark",
	"larva",
	"lemming",
	"lemur",
	"leopard",
	"liger",
	"lion",
	"lionfish",
	"lizard",
	"llama",
	"lobster",
	"loris",
	"lynx",
	"macaw",
	"maggot",
	"mallard",
	"mammoth",
	"manatee",
	"mantis",
	"mare",
	"marlin",
	"marmot",
	"marten",
	"martin",
	"mayfly",
	"meerkat",
	"midge",
	"millipede",
	"mink",
	"mole",
	"mongoose",
	"monkey",
	"moose",
	"moth",
	"mouse",
	"mule",
	"myna",
	"newt",
	"niklas",
	"nils",
	"nuthatch",
	"ocelot",
	"octopus",
	"okapi",
	"opossum",
	"orangutan",
	"oryx",
	"osprey",
	"ostrich",
	"otter",
	"owl",
	"ox",
	"panda",
	"panther",
	"parakeet",
	"parrot",
	"peacock",
	"pelican",
	"penguin",
	"pig",
	"pigeon",
	"piranha",
	"platypus",
	"polecat",
	"pony",
	"poodle",
	"porpoise",
	"puffin",
	"pug",
	"puma",
	"quail",
	"rabbit",
	"racoon",
	"rat",
	"raven",
	"ray",
	"reindeer",
	"robin",
	"rook",
	"rooster",
	"salmon",
	"samuel",
	"sawfish",
	"scallop",
	"seahorse",
	"seal",
	"shad",
	"shark",
	"sheep",
	"shell",
	"shrike",
	"shrimp",
	"skate",
	"skunk",
	"sloth",
	"slug",
	"snail",
	"snake",
	"sparrow",
	"spider",
	"squid",
	"squirrel",
	"starfish",
	"stingray",
	"stork",
	"swallow",
	"swan",
	"tadpole",
	"tapir",
	"termite",
	"tern",
	"thrush",
	"tiger",
	"toad",
	"tortoise",
	"toucan",
	"trout",
	"tuna",
	"turkey",
	"turtle",
	"vole",
	"vulture",
	"wallaby",
	"walrus",
	"warbler",
	"warthog",
	"wasp",
	"weasel",
	"whale",
	"wolf",
	"wombat",
	"worm",
	"wren",
	"yak",
	"zebra",
];

export const adjectives = [
	"acidic",
	"active",
	"actual",
	"agent",
	"ago",
	"alert",
	"alive",
	"aloof",
	"antsy",
	"any",
	"aqua",
	"arable",
	"awake",
	"aware",
	"away",
	"awful",
	"bad",
	"bald",
	"basic",
	"best",
	"big",
	"bland",
	"blue",
	"bold",
	"born",
	"brave",
	"brief",
	"bright",
	"broad",
	"busy",
	"calm",
	"candid",
	"careful",
	"caring",
	"chunky",
	"civil",
	"clean",
	"clear",
	"close",
	"cool",
	"cozy",
	"crazy",
	"crisp",
	"cuddly",
	"curly",
	"cute",
	"dark",
	"day",
	"deft",
	"direct",
	"dirty",
	"dizzy",
	"drab",
	"dry",
	"due",
	"dull",
	"each",
	"early",
	"east",
	"elegant",
	"empty",
	"equal",
	"even",
	"every",
	"extra",
	"factual",
	"fair",
	"fancy",
	"few",
	"fine",
	"fit",
	"flaky",
	"flat",
	"fluffy",
	"formal",
	"frail",
	"free",
	"fresh",
	"front",
	"full",
	"fun",
	"funny",
	"fuzzy",
	"game",
	"gaudy",
	"giant",
	"glad",
	"good",
	"grand",
	"grassy",
	"gray",
	"great",
	"green",
	"gross",
	"happy",
	"heavy",
	"helpful",
	"heroic",
	"home",
	"honest",
	"hour",
	"house",
	"icy",
	"ideal",
	"inclusive",
	"inner",
	"jolly",
	"jumpy",
	"just",
	"keen",
	"key",
	"kind",
	"knotty",
	"known",
	"large",
	"last",
	"late",
	"lazy",
	"least",
	"left",
	"legal",
	"less",
	"level",
	"light",
	"lime",
	"livid",
	"lofty",
	"long",
	"loose",
	"lost",
	"loud",
	"loved",
	"low",
	"lower",
	"lucky",
	"mad",
	"main",
	"major",
	"male",
	"many",
	"maroon",
	"mealy",
	"mean",
	"mellow",
	"merry",
	"mild",
	"minor",
	"misty",
	"moving",
	"muddy",
	"mushy",
	"neat",
	"new",
	"next",
	"nice",
	"nimble",
	"noble",
	"noisy",
	"north",
	"novel",
	"odd",
	"ok",
	"only",
	"orange",
	"ornate",
	"patchy",
	"patient",
	"petty",
	"pink",
	"plain",
	"plane",
	"polite",
	"pretty",
	"proof",
	"proud",
	"quaint",
	"quick",
	"quiet",
	"raw",
	"real",
	"red",
	"round",
	"royal",
	"sad",
	"safe",
	"salty",
	"same",
	"sea",
	"seemly",
	"sharp",
	"short",
	"shy",
	"silly",
	"simple",
	"sleek",
	"slimy",
	"slow",
	"small",
	"smart",
	"smug",
	"soft",
	"solid",
	"sound",
	"sour",
	"spare",
	"spicy",
	"spry",
	"stale",
	"steep",
	"still",
	"stock",
	"stout",
	"strong",
	"suave",
	"such",
	"sunny",
	"super",
	"sweet",
	"swift",
	"tame",
	"tangy",
	"tasty",
	"teal",
	"teary",
	"tense",
	"that",
	"these",
	"this",
	"tidy",
	"tiny",
	"tired",
	"top",
	"topical",
	"tough",
	"trick",
	"trite",
	"true",
	"upper",
	"vexed",
	"vivid",
	"wacky",
	"warm",
	"watery",
	"weak",
	"weary",
	"weird",
	"white",
	"whole",
	"wide",
	"wild",
	"wise",
	"witty",
	"yummy",
	"zany",
	"zesty",
	"zippy",
];

export const adverbs = [
	"ablaze",
	"about",
	"above",
	"abroad",
	"across",
	"adrift",
	"afloat",
	"after",
	"again",
	"ahead",
	"alike",
	"all",
	"almost",
	"alone",
	"along",
	"aloud",
	"always",
	"amazing",
	"anxious",
	"anywhere",
	"apart",
	"around",
	"arrogant",
	"aside",
	"asleep",
	"awkward",
	"back",
	"bashful",
	"beautiful",
	"before",
	"behind",
	"below",
	"beside",
	"besides",
	"beyond",
	"bitter",
	"bleak",
	"blissful",
	"boldly",
	"bravely",
	"briefly",
	"brightly",
	"brisk",
	"busily",
	"calmly",
	"carefully",
	"careless",
	"cautious",
	"certain",
	"cheerful",
	"clearly",
	"clever",
	"closely",
	"closer",
	"colorful",
	"common",
	"correct",
	"cross",
	"cruel",
	"curious",
	"daily",
	"dainty",
	"daring",
	"dear",
	"desperate",
	"diligent",
	"doubtful",
	"doubtless",
	"down",
	"downwards",
	"dreamily",
	"eager",
	"easily",
	"either",
	"elegantly",
	"else",
	"elsewhere",
	"enormous",
	"enough",
	"ever",
	"famous",
	"far",
	"fast",
	"fervent",
	"fierce",
	"fondly",
	"foolish",
	"forever",
	"forth",
	"fortunate",
	"forward",
	"frank",
	"freely",
	"frequent",
	"fully",
	"general",
	"generous",
	"gladly",
	"graceful",
	"grateful",
	"gratis",
	"half",
	"happily",
	"hard",
	"harsh",
	"hearty",
	"helpless",
	"here",
	"highly",
	"hitherto",
	"how",
	"however",
	"hurried",
	"immediate",
	"in",
	"indeed",
	"inland",
	"innocent",
	"inside",
	"instant",
	"intense",
	"inward",
	"jealous",
	"jovial",
	"joyful",
	"jubilant",
	"keenly",
	"kindly",
	"knowing",
	"lately",
	"lazily",
	"lightly",
	"likely",
	"little",
	"live",
	"loftily",
	"longing",
	"loosely",
	"loudly",
	"loving",
	"loyal",
	"luckily",
	"madly",
	"maybe",
	"meanwhile",
	"mocking",
	"monthly",
	"moreover",
	"much",
	"near",
	"neatly",
	"neither",
	"nervous",
	"never",
	"noisily",
	"normal",
	"not",
	"now",
	"nowadays",
	"nowhere",
	"oddly",
	"off",
	"official",
	"often",
	"on",
	"once",
	"open",
	"openly",
	"opposite",
	"otherwise",
	"out",
	"outside",
	"over",
	"overall",
	"overhead",
	"overnight",
	"overseas",
	"parallel",
	"partial",
	"past",
	"patiently",
	"perfect",
	"perhaps",
	"physical",
	"playful",
	"politely",
	"potential",
	"powerful",
	"presto",
	"profound",
	"prompt",
	"proper",
	"proudly",
	"punctual",
	"quickly",
	"quizzical",
	"rare",
	"ravenous",
	"ready",
	"really",
	"reckless",
	"regular",
	"repeated",
	"restful",
	"rightful",
	"rigid",
	"rude",
	"sadly",
	"safely",
	"scarce",
	"scary",
	"searching",
	"seeming",
	"seldom",
	"selfish",
	"separate",
	"serious",
	"shaky",
	"sheepish",
	"silent",
	"sleepy",
	"smooth",
	"softly",
	"solemn",
	"solidly",
	"sometimes",
	"speedy",
	"stealthy",
	"stern",
	"strict",
	"stubborn",
	"sudden",
	"supposed",
	"sweetly",
	"swiftly",
	"tender",
	"tensely",
	"thankful",
	"tight",
	"too",
	"twice",
	"under",
	"untrue",
	"uphill",
	"upward",
	"vaguely",
	"vainly",
	"vastly",
	"warmly",
	"wearily",
	"weekly",
	"well",
	"wisely",
	"within",
	"wrongly",
	"yonder",
];

export const verbs = [
	"absorb",
	"accept",
	"achieve",
	"adapt",
	"adore",
	"advise",
	"affirm",
	"agree",
	"aid",
	"aim",
	"amaze",
	"amuse",
	"animate",
	"approve",
	"arise",
	"arrive",
	"ascend",
	"ask",
	"aspire",
	"assure",
	"attend",
	"bake",
	"bask",
	"beam",
	"believe",
	"belong",
	"bend",
	"blend",
	"bless",
	"blink",
	"bloom",
	"boil",
	"boost",
	"borrow",
	"breathe",
	"bubble",
	"build",
	"bump",
	"burn",
	"buy",
	"buzz",
	"care",
	"catch",
	"charm",
	"cheer",
	"cherish",
	"chop",
	"clap",
	"clasp",
	"climb",
	"clip",
	"coax",
	"comfort",
	"commend",
	"compose",
	"conquer",
	"cook",
	"create",
	"cry",
	"cuddle",
	"cure",
	"cut",
	"dance",
	"dare",
	"dart",
	"dash",
	"dazzle",
	"delight",
	"devour",
	"dial",
	"dig",
	"dine",
	"dream",
	"drip",
	"drop",
	"drum",
	"dust",
	"earn",
	"edit",
	"embrace",
	"emerge",
	"empower",
	"enchant",
	"endure",
	"engage",
	"enjoy",
	"enrich",
	"evoke",
	"exhale",
	"expand",
	"explore",
	"express",
	"fade",
	"fall",
	"favor",
	"fear",
	"feast",
	"feel",
	"fetch",
	"file",
	"find",
	"flip",
	"flop",
	"flow",
	"fold",
	"fond",
	"forgive",
	"foster",
	"fry",
	"fulfill",
	"gasp",
	"gaze",
	"gleam",
	"glow",
	"grace",
	"grasp",
	"greet",
	"grin",
	"grip",
	"grow",
	"gulp",
	"hack",
	"harbor",
	"heal",
	"heart",
	"hike",
	"hint",
	"honor",
	"hope",
	"hug",
	"hunt",
	"hurl",
	"hush",
	"imagine",
	"inspire",
	"intend",
	"jest",
	"jolt",
	"jump",
	"kick",
	"kiss",
	"laugh",
	"launch",
	"lead",
	"leap",
	"learn",
	"lend",
	"lift",
	"link",
	"list",
	"lock",
	"loop",
	"love",
	"mend",
	"mix",
	"mop",
	"nail",
	"nourish",
	"nudge",
	"nurture",
	"offer",
	"pat",
	"pause",
	"pave",
	"peek",
	"peel",
	"persist",
	"pet",
	"pick",
	"pinch",
	"play",
	"pop",
	"pout",
	"praise",
	"pray",
	"pride",
	"promise",
	"propel",
	"prosper",
	"pull",
	"push",
	"quell",
	"quiz",
	"race",
	"radiate",
	"read",
	"reap",
	"relish",
	"renew",
	"reside",
	"rest",
	"revive",
	"ripple",
	"rise",
	"roam",
	"roar",
	"rush",
	"sail",
	"savor",
	"scold",
	"scoop",
	"seek",
	"sew",
	"shine",
	"sing",
	"skip",
	"slide",
	"slurp",
	"smile",
	"snap",
	"snip",
	"soar",
	"spark",
	"spin",
	"splash",
	"sprout",
	"spur",
	"stab",
	"startle",
	"stir",
	"stop",
	"strive",
	"succeed",
	"support",
	"surge",
	"sway",
	"swim",
	"talk",
	"tap",
	"taste",
	"tear",
	"tend",
	"thrive",
	"tickle",
	"transform",
	"treasure",
	"treat",
	"trim",
	"trip",
	"trust",
	"twirl",
	"twist",
	"type",
	"urge",
	"value",
	"vent",
	"view",
	"walk",
	"wave",
	"win",
	"wish",
	"work",
	"yell",
	"zap",
	"zip",
	"zoom",
];
